import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import { useAuth } from "../AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const dest = location.pathname.startsWith("/credit") ? location.pathname : "/credit/app";

    (async () => {
      try {
        const { data } = await api.post("/auth/oauth/emergent/session", { session_id: sessionId });
        localStorage.setItem("cc_token", data.token);
        setUser(data.user);
        toast.success(data.linked ? "Google account linked" : "Signed in with Google");
        window.history.replaceState(null, "", dest);
        navigate(dest, { replace: true });
      } catch (e) {
        toast.error(e.response?.data?.detail || "Google sign-in failed. Please try again.");
        window.history.replaceState(null, "", "/credit/login");
        navigate("/credit/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="cc cc-bg min-h-screen flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <div className="h-8 w-8 rounded-full border-2 border-blue-400 border-t-transparent animate-spin" />
      <p className="text-sm text-slate-400">Completing Google sign-in…</p>
    </div>
  );
}
